var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { Mutation, State, Getter } from 'vuex-class';
import LoaderService from 'src/lib/services/Loader.service';
import { World } from 'src/lib/graphics/World';
import { SET_CURRENT_DATE, GET_CURRENT_SCENARIO_SECONDS_PER_TICK } from 'src/stores/viewer/config';
var GLRenderer = /** @class */ (function (_super) {
    __extends(GLRenderer, _super);
    function GLRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rendererID = 'renderer';
        return _this;
    }
    GLRenderer.prototype.tick = function () {
        var _this = this;
        this.world.render();
        window.requestAnimationFrame(function () { return _this.tick(); });
        if (this.isPlaying) {
            this.setCurrentDate(this.world.date);
        }
    };
    GLRenderer.prototype.loadWorld = function () {
        var _this = this;
        LoaderService.load().then(function (res) {
            _this.world = new World("#" + _this.rendererID);
            _this.world.isPlaying = _this.isPlaying;
            _this.world.setScenario(_this.currentScenario);
            _this.world.create();
            _this.world.setCameraPosition(_this.currentCameraPosition);
            _this.setCurrentDate(_this.world.date);
            _this.tick();
        });
    };
    GLRenderer.prototype.onChangeIsPlaying = function (isPlaying) {
        this.world.isPlaying = isPlaying;
    };
    GLRenderer.prototype.onChangeCurrentCameraPosition = function (planetId) {
        this.world.setCameraPosition(planetId);
    };
    GLRenderer.prototype.onChangeCurrentSecondsPerTick = function (tick) {
        this.world.setSecondsPerTick(tick);
    };
    GLRenderer.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.loadWorld();
        });
    };
    __decorate([
        Mutation(SET_CURRENT_DATE)
    ], GLRenderer.prototype, "setCurrentDate", void 0);
    __decorate([
        State(function (state) { return state.viewer.currentScenario; })
    ], GLRenderer.prototype, "currentScenario", void 0);
    __decorate([
        State(function (state) { return state.viewer.isPlaying; })
    ], GLRenderer.prototype, "isPlaying", void 0);
    __decorate([
        State(function (state) { return state.viewer.currentCameraPosition; })
    ], GLRenderer.prototype, "currentCameraPosition", void 0);
    __decorate([
        Getter(GET_CURRENT_SCENARIO_SECONDS_PER_TICK)
    ], GLRenderer.prototype, "currentSecondsPerTick", void 0);
    __decorate([
        Watch('isPlaying')
    ], GLRenderer.prototype, "onChangeIsPlaying", null);
    __decorate([
        Watch('currentCameraPosition')
    ], GLRenderer.prototype, "onChangeCurrentCameraPosition", null);
    __decorate([
        Watch('currentSecondsPerTick')
    ], GLRenderer.prototype, "onChangeCurrentSecondsPerTick", null);
    GLRenderer = __decorate([
        Component({
            name: 'GLRenderer'
        })
    ], GLRenderer);
    return GLRenderer;
}(Vue));
export default GLRenderer;
